import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2'
import { Button, Card, CardContent, Typography, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ShippingCarrierAPI } from '../../api/shippingCarrierApi';
import useTranslation from '../../hooks/useTranslation';

const ShippingCarrierList = ({ fulfillmentCenterId }) => {
  const { t } = useTranslation();
  const [carriers, setCarriers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingCarrier, setEditingCarrier] = useState(null);
  const [newCarrier, setNewCarrier] = useState({ name: '', tracking_url: '' });

  const fetchCarriers = async () => {
    try {
      const response = await ShippingCarrierAPI.getShippingCarriers(fulfillmentCenterId);
      setCarriers(response.data);
    } catch (error) {
      console.error(t('labels.shipping_carriers.error_fetch'), error);
    }
  };

  const handleAddCarrier = async () => {
    try {
      await ShippingCarrierAPI.createShippingCarrier(fulfillmentCenterId, newCarrier);
      setNewCarrier({ name: '', tracking_url: '' });
      setModalOpen(false);
      fetchCarriers();
    } catch (error) {
      console.error(t('labels.shipping_carriers.error_add'), error);
    }
  };

  const handleEditCarrier = async () => {
    try {
      await ShippingCarrierAPI.updateShippingCarrier(editingCarrier.id, editingCarrier);
      setEditingCarrier(null);
      fetchCarriers();
    } catch (error) {
      console.error(t('labels.shipping_carriers.error_edit'), error);
    }
  };

  const handleDeleteCarrier = async (carrierId) => {
    try {
      await ShippingCarrierAPI.deleteShippingCarrier(carrierId);
      fetchCarriers();
    } catch (error) {
      console.error(t('labels.shipping_carriers.error_delete'), error);
    }
  };

  useEffect(() => {
    if (fulfillmentCenterId) {
      fetchCarriers();
    }
  }, [fulfillmentCenterId]);

  return (
    <Card variant="contained">
      <CardContent>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <Typography variant="h6">{t('labels.shipping_carriers.title')}</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setModalOpen(true)}
          >
            {t('labels.shipping_carriers.add')}
          </Button>
        </div>
        <Grid container spacing={2}>
          {carriers.map((carrier) => (
            <Grid size={12} key={carrier.id}>
              <Card variant="outlined">
                <CardContent style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>{carrier.name}</Typography>
                    <Typography variant="body2" color="textSecondary">
                      {carrier.tracking_url || t('labels.shipping_carriers.no_tracking_url')}
                    </Typography>
                  </div>
                  <div>
                    <IconButton
                      onClick={() => setEditingCarrier(carrier)}
                      style={{ color: 'black' }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => handleDeleteCarrier(carrier.id)}
                      style={{ color: 'black' }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </CardContent>
      <Dialog open={modalOpen || !!editingCarrier} onClose={() => {
        setModalOpen(false);
        setEditingCarrier(null);
      }}>
        <DialogTitle>
          {editingCarrier ? t('labels.shipping_carriers.edit') : t('labels.shipping_carriers.add')}
        </DialogTitle>
        <DialogContent>
          <TextField
            label={t('labels.shipping_carriers.name')}
            value={editingCarrier ? editingCarrier.name : newCarrier.name}
            onChange={(e) =>
              editingCarrier
                ? setEditingCarrier({ ...editingCarrier, name: e.target.value })
                : setNewCarrier({ ...newCarrier, name: e.target.value })
            }
            fullWidth
            style={{ marginBottom: '10px' }}
          />
          <TextField
            label={t('labels.shipping_carriers.tracking_url')}
            value={editingCarrier ? editingCarrier.tracking_url : newCarrier.tracking_url}
            onChange={(e) =>
              editingCarrier
                ? setEditingCarrier({ ...editingCarrier, tracking_url: e.target.value })
                : setNewCarrier({ ...newCarrier, tracking_url: e.target.value })
            }
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setModalOpen(false);
              setEditingCarrier(null);
            }}
          >
            {t('labels.shipping_carriers.cancel')}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={editingCarrier ? handleEditCarrier : handleAddCarrier}
          >
            {editingCarrier ? t('labels.shipping_carriers.save') : t('labels.shipping_carriers.add')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
export default ShippingCarrierList;